export enum RegistrationTypes {
    open = 'open',
    openWithRegistration = 'openWithRegistration',
    closedWithRegistrations = 'closedWithRegistrations',
    hidden = 'hidden'
}